import { catalogToSelectOptions } from "utils/general";

import type { ItfObjJson } from "types/commons";
import type { FiscalDocsModes } from "types/taxes";

export const FISCAL_DOC_ISSUANCE_MODE: { [p: string]: { value: FiscalDocsModes; description: string } } = {
  invoice: {
    value: "invoice",
    description: "Factura",
  },
  tax_retention: {
    value: "tax_retention",
    description: "Retención de Impuesto",
  },
};

export const CATALOG_PAYMENT_METHOD = {
  PUE: "Pago en una sola exhibición",
  PPD: "Pagos en parcialidades o diferido",
};

export const CATALOG_PAYMENT_TYPE: ItfObjJson = {
  "01": "Efectivo",
  "02": "Transferencia electrónica de fondos",
  "03": "Tarjeta de crédito",
  "04": "Monedero electrónico",
  "05": "Dinero electrónico",
  "06": "Tarjeta de débito",
  "07": "Tarjeta de servicios",
  "08": "Intermediario pagos",
  "09": "Otros ingresos por premios, bonificaciones o análogos",
};

export const CATALOG_SERVICE_TYPE: ItfObjJson = {
  "01": "Transporte terrestre de pasajeros",
  "02": "Entrega de alimentos preparados",
  "03": "Entrega de bienes (distintos de alimentos preparados)",
  "04": "Hospedaje",
  "05": "Comercio de bienes",
  "06": "Otro tipo de servicios",
  "07": "Descarga o acceso a contenido digital, así como otros contenidos multimedia",
  "08": "Clubes en línea y páginas de citas.",
  "09": "Enseñanza a distancia o test o ejercicios.",
};

export const CATALOG_SERVICE_SUB_TYPE: ItfObjJson = {
  "01": "Personal",
  "02": "Compartido",
  "03": "Plus",
  "04": "Cancelación",
};

export const CATALOG_PERIODICITY: ItfObjJson = {
  "01": "Semanal",
  "02": "Mensual",
  "03": "Diario",
  "04": "Quincenal",
  "05": "Otro",
};

export const CATALOG_PAYMENT_METHOD_MAP_OPTS = catalogToSelectOptions(CATALOG_PAYMENT_METHOD);

export const CATALOG_PAYMENT_TYPE_MAP_OPTS = catalogToSelectOptions(CATALOG_PAYMENT_TYPE);

export const CATALOG_SERVICE_TYPE_MAP_OPTS = catalogToSelectOptions(CATALOG_SERVICE_TYPE);

export const CATALOG_SERVICE_SUB_TYPE_MAP_OPTS = catalogToSelectOptions(CATALOG_SERVICE_SUB_TYPE);

export const CATALOG_PERIODICITY_MAP_OPTS = catalogToSelectOptions(CATALOG_PERIODICITY);
